<template>
  <div class="discount-conversion">
      <el-form :inline="true" :model="filters" size="small" class="conversion-toolbar" @submit.native.prevent="search">
        <el-form-item label="任务名称">
          <el-input v-model="filters.taskName" placeholder="输入任务名称搜索" clearable />
        </el-form-item>
        <el-form-item label="店铺名称">
          <brand-select v-model="filters.vendorId" :data="vendorOptions" placeholder="全部店铺" clearable />
        </el-form-item>
        <el-form-item label="类目">
          <el-select v-model="filters.category" placeholder="全部类目" clearable>
            <el-option v-for="category in categories" :key="category" :label="category" :value="category" />
          </el-select>
        </el-form-item>
        <el-form-item label="季节">
          <el-select v-model="filters.season" placeholder="全部季节" filterable clearable :loading="optionsLoading">
            <el-option v-for="season in seasons" :key="season.seasonCode" :label="season.chineseName || season.seasonCode" :value="season.seasonCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="filters.status" placeholder="全部状态" clearable>
            <el-option v-for="status in statuses" :key="status.value" :label="status.label" :value="status.value" />
          </el-select>
        </el-form-item>
        <div class="conversion-actions">
          <el-button size="small" type="primary" @click="search">查询</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </div>
       <div class="conversion-actions">
          <el-button size="small" @click="openRequirements">任务要求</el-button>
          <el-button size="small" type="primary" @click="openTask">创建任务</el-button>
        </div>
      </el-form>

      <el-table v-loading="listLoading" :data="pageTasks" height="100%" empty-text="暂无符合条件的任务" class="conversion-table">
        <el-table-column prop="id" label="任务 ID" width="90" />
        <el-table-column prop="taskName" label="任务名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="店铺名称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ vendorName(scope.row.vendorId) }}</template>
        </el-table-column>
        <el-table-column prop="category" label="类目" width="100" />
        <el-table-column prop="season" label="季节" width="100" />
        <el-table-column label="任务要求" min-width="150">
          <template slot-scope="scope">
            <button v-if="scope.row.requirementContent" class="conversion-text-link" :title="scope.row.requirementContent" @click="openDetail(scope.row, 'requirement')">{{ truncate(scope.row.requirementContent) }}</button>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column v-for="column in fileColumns" :key="column.key" :label="column.label" min-width="180">
          <template slot-scope="scope"><file-links :urls="scope.row[column.key] || ''" /></template>
        </el-table-column>
        <el-table-column label="任务状态" width="100">
          <template slot-scope="scope"><el-tag size="small" :type="statusInfo(scope.row.status).type">{{ statusInfo(scope.row.status).label }}</el-tag></template>
        </el-table-column>
        <el-table-column label="任务结果" min-width="120">
          <template slot-scope="scope">
            <div class="conversion-result-actions">
              <el-button v-if="scope.row.resultSummary || scope.row.errorMsg" type="text" size="small" @click="openDetail(scope.row, 'result')">查看</el-button>
              <el-button v-if="hasResultFiles(scope.row)" type="text" size="small" :loading="isDownloadingTask(scope.row.id)" @click="downloadResultZip(scope.row)">下载 ZIP</el-button>
              <span v-if="!scope.row.resultSummary && !scope.row.errorMsg && !hasResultFiles(scope.row)">—</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务结果文件" min-width="190">
          <template slot-scope="scope"><file-links :urls="scope.row.resultFileUrls || ''" /></template>
        </el-table-column>
        <el-table-column label="创建时间" width="170"><template slot-scope="scope">{{ formatTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="任务结束时间" width="170"><template slot-scope="scope">{{ formatTime(scope.row.finishedAt) }}</template></el-table-column>
        <el-table-column label="任务耗时" width="110"><template slot-scope="scope">{{ formatDuration(scope.row.durationMs) }}</template></el-table-column>
      </el-table>
      <div class="conversion-pagination">
        <el-pagination :current-page="page" :page-size="pageSize" :total="tasks.length" layout="total, prev, pager, next" @current-change="page = $event" />
      </div>

    <el-dialog title="任务要求" :visible.sync="requirementsVisible" width="720px" custom-class="premium-minimal-dialog conversion-dialog" :close-on-click-modal="false">
      <div class="conversion-requirement-toolbar">
        <el-input v-model="requirementKeyword" size="small" placeholder="输入任务要求名称搜索" clearable />
        <el-button type="primary" size="small" @click="openRequirementEditor()">创建任务要求</el-button>
      </div>
      <div v-loading="requirementsLoading" class="conversion-requirements">
        <div v-for="(requirement, index) in filteredRequirements" :key="requirement.id" class="conversion-requirement">
          <span class="conversion-number">{{ index + 1 }}.</span>
          <div class="conversion-requirement-body"><strong>{{ requirement.name }}</strong><p>{{ requirement.content }}</p></div>
          <el-button type="text" size="small" @click="openRequirementEditor(requirement)">编辑</el-button>
        </div>
        <div v-if="!requirementsLoading && !requirementsError && !filteredRequirements.length" class="conversion-empty">暂无符合条件的任务要求</div>
      </div>
    </el-dialog>

    <el-dialog :title="requirementDraft.id == null ? '创建任务要求' : '编辑任务要求'" :visible.sync="requirementEditorVisible" width="600px" append-to-body custom-class="premium-minimal-dialog conversion-dialog" :close-on-click-modal="false" :before-close="closeRequirementEditor" :show-close="!requirementSaving" :close-on-press-escape="!requirementSaving">
      <el-form ref="requirementForm" :model="requirementDraft" :rules="requirementRules" label-position="top" :disabled="requirementSaving">
        <el-form-item label="任务要求名称" prop="name"><el-input v-model="requirementDraft.name" maxlength="128" placeholder="请输入任务要求名称" /></el-form-item>
        <el-form-item label="任务要求" prop="content"><el-input v-model="requirementDraft.content" type="textarea" :rows="7" placeholder="请输入任务要求的具体内容" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="requirementSaving" @click="requirementEditorVisible = false">取消</el-button><el-button type="primary" :loading="requirementSaving" @click="saveRequirement">确定</el-button></span>
    </el-dialog>

    <el-dialog title="创建任务" :visible.sync="taskVisible" width="640px" custom-class="premium-minimal-dialog conversion-dialog" :close-on-click-modal="false" :show-close="!taskSaving && !uploadBusy" :close-on-press-escape="!taskSaving && !uploadBusy" :before-close="closeTask">
      <el-form ref="taskForm" :model="taskDraft" :rules="taskRules" label-position="top" :disabled="taskSaving">
        <el-form-item label="任务名称" prop="taskName"><el-input v-model="taskDraft.taskName" maxlength="128" placeholder="请输入任务名称" /></el-form-item>
        <el-form-item label="店铺名称" prop="vendorId">
          <brand-select v-model="taskDraft.vendorId" :data="vendorOptions" placeholder="请选择店铺名称" clearable :disabled="optionsLoading" />
        </el-form-item>
        <div class="conversion-form-grid">
          <el-form-item label="类目" prop="category"><el-select v-model="taskDraft.category" placeholder="请选择类目" multiple collapse-tags><el-option v-for="category in categories" :key="category" :label="category" :value="category" /></el-select></el-form-item>
          <el-form-item label="季节" prop="season"><el-select v-model="taskDraft.season" filterable placeholder="请选择季节" :loading="optionsLoading" multiple collapse-tags><el-option v-for="season in seasons" :key="season.seasonCode" :label="season.chineseName || season.seasonCode" :value="season.seasonCode" /></el-select></el-form-item>
        </div>
        <el-form-item label="任务要求" prop="requirementIds">
          <div v-for="(row, index) in requirementRows" :key="row.key" class="conversion-requirement-input">
            <span>{{ index + 1 }}.</span>
            <el-select v-model="row.id" filterable clearable placeholder="请选择任务要求" :loading="requirementsLoading" @change="syncRequirementIds">
              <el-option v-for="requirement in enabledRequirements" :key="requirement.id" :label="requirement.name" :value="requirement.id" :disabled="requirementSelected(requirement.id, row)" />
            </el-select>
            <el-button icon="el-icon-close" :disabled="requirementRows.length === 1" :aria-label="'删除第' + (index + 1) + '条要求'" @click="removeRequirementRow(row.key)" />
          </div>
          <el-button type="text" size="small" @click="addRequirementRow">+ 添加要求</el-button>
        </el-form-item>
        <el-form-item v-for="field in uploadFields" :key="field.key" :label="field.label" :prop="field.key">
          <file-upload v-if="taskVisible" :key="taskSession + field.key" :label="field.shortLabel" :disabled="taskSaving" @input="setFiles(field.key, $event)" @busy="uploading[field.key] = $event" />
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="taskSaving || uploadBusy" @click="taskVisible = false">取消</el-button><el-button type="primary" :loading="taskSaving" :disabled="uploadBusy || taskSaving" @click="saveTask">确定</el-button></span>
    </el-dialog>

    <el-dialog :title="detailKind === 'result' ? '任务结果' : '任务要求'" :visible.sync="detailVisible" width="800px" custom-class="premium-minimal-dialog conversion-dialog">
      <div v-loading="detailLoading" class="conversion-detail">
        <template v-if="detailTask && !detailError">
          <p class="conversion-detail-meta">{{ detailTask.id }} · {{ vendorName(detailTask.vendorId) }} · {{ detailTask.category }} · {{ detailTask.season }} · {{ statusInfo(detailTask.status).label }}</p>
          <template v-if="detailKind === 'requirement'"><div class="conversion-detail-text">{{ detailTask.requirementContent || '—' }}</div></template>
          <template v-else>
            <div class="conversion-result"><div class="conversion-markdown" v-html="resultSummaryHtml"></div></div>
            <div v-if="detailTask.errorMsg" class="conversion-notice" role="alert">失败原因：{{ detailTask.errorMsg }}</div>
            <file-links :urls="detailTask.resultFileUrls || ''" />
          </template>
        </template>
      </div>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { getComboVendorListRF } from '@/api/trace';
import { seasonList } from '@/api/merchants';
import { getRequirements, createRequirement, updateRequirement, getTasks, getTask, downloadTaskResultFiles, createTask } from '@/api/discountConversion';
import renderMarkdown from '@/utils/markdown';
import { downloadFile } from '@/utils/functions';
import BrandSelect from '@/views/components/brandSelect.vue';
import FileLinks from './FileLinks.vue';
import FileUpload from './FileUpload.vue';

const emptyFilters = () => ({ taskName: '', vendorId: '', category: '', season: '', status: '' });
const emptyTask = () => ({ taskName: '', vendorId: null, category: [], season: [], requirementIds: [], sourceFileUrls: [], caseSourceFileUrls: [], caseStandardFileUrls: [] });
const requiredText = message => [{ required: true, whitespace: true, message, trigger: 'blur' }];

export default {
  name: 'DiscountConvert',
  components: { BrandSelect, FileLinks, FileUpload },
  data() {
    return {
      filters: emptyFilters(), appliedFilters: emptyFilters(), tasks: [], page: 1, pageSize: 10,
      listLoading: false, listSequence: 0,
      downloadingTasks: {},
      vendors: [], vendorOptions: [], seasons: [], optionsLoading: false, optionsError: '',
      categories: ['Adult', 'Kids'],
      statuses: [
        { value: 'PENDING', label: '待处理', type: 'info' },
        { value: 'RUNNING', label: '处理中', type: '' },
        { value: 'SUCCESS', label: '已完成', type: 'success' },
        { value: 'FAILED', label: '失败', type: 'danger' },
        { value: 'CANCELED', label: '已取消', type: 'warning' }
      ],
      fileColumns: [{ key: 'sourceFileUrls', label: '源文件' }, { key: 'caseSourceFileUrls', label: '案例源文件' }, { key: 'caseStandardFileUrls', label: '案例标准文件' }],
      requirements: [], requirementsVisible: false, requirementsLoading: false, requirementsError: '', requirementKeyword: '',
      requirementEditorVisible: false, requirementDraft: { id: null, name: '', content: '' }, requirementSaving: false,
      requirementRules: { name: requiredText('请输入任务要求名称'), content: requiredText('请输入任务要求正文') },
      taskVisible: false, taskDraft: emptyTask(), taskSaving: false, taskSession: 0,
      requirementRows: [{ key: 0, id: null }], rowSequence: 0,
      uploading: { sourceFileUrls: false, caseSourceFileUrls: false, caseStandardFileUrls: false },
      uploadFields: [{ key: 'sourceFileUrls', label: '上传源文件', shortLabel: '源文件' }, { key: 'caseSourceFileUrls', label: '上传案例源文件', shortLabel: '案例源文件' }, { key: 'caseStandardFileUrls', label: '上传案例标准文件', shortLabel: '案例标准文件' }],
      taskRules: {
        taskName: requiredText('请输入任务名称'), vendorId: [{ required: true, message: '请选择店铺名称', trigger: 'change' }],
        category: [{ type: 'array', required: true, min: 1, message: '请选择类目', trigger: 'change' }], season: [{ type: 'array', required: true, min: 1, message: '请选择季节', trigger: 'change' }],
        requirementIds: [{ type: 'array', required: true, min: 1, message: '请至少选择一条任务要求', trigger: 'change' }],
        sourceFileUrls: [{ type: 'array', required: true, min: 1, message: '请上传源文件', trigger: 'change' }]
      },
      detailVisible: false, detailKind: 'requirement', detailId: null, detailTask: null, detailLoading: false, detailError: '', detailSequence: 0,
      refreshTimer: null, active: true, alive: true
    };
  },
  computed: {
    pageTasks() { return this.tasks.slice((this.page - 1) * this.pageSize, this.page * this.pageSize); },
    enabledRequirements() { return this.requirements.filter(item => Number(item.enabled) === 1); },
    filteredRequirements() {
      const keyword = this.requirementKeyword.trim().toLowerCase();
      return this.requirements.filter(item => String(item.name || '').toLowerCase().includes(keyword));
    },
    uploadBusy() { return Object.keys(this.uploading).some(key => this.uploading[key]); },
    vendorNames() {
      return this.vendors.reduce((names, vendor) => { names[vendor.vendorId] = vendor.vendorName; return names; }, {});
    },
    resultSummaryHtml() { return renderMarkdown(this.detailTask && this.detailTask.resultSummary || '暂无处理结果'); }
  },
  created() {
    this.loadOptions();
    this.loadRequirements();
    this.loadTasks();
  },
  activated() {
    this.active = true;
    if (!this.listLoading) this.loadTasks(true);
  },
  deactivated() {
    this.active = false;
    clearTimeout(this.refreshTimer);
  },
  beforeDestroy() {
    this.alive = false;
    clearTimeout(this.refreshTimer);
  },
  methods: {
    errorText(error) { return (error && error.message) || (typeof error === 'string' && error) || '请求失败，请重试'; },
    vendorName(id) { return this.vendorNames[id] || (id == null ? '—' : String(id)); },
    statusInfo(value) { return this.statuses.find(item => item.value === value) || { label: value || '—', type: 'info' }; },
    truncate(value) { const text = String(value || ''); return text.length > 10 ? `${text.slice(0, 10)}...` : text; },
    formatTime(value) {
      if (!value) return '—';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      const pad = number => String(number).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    formatDuration(value) {
      if (value == null || value === '') return '—';
      const milliseconds = Number(value);
      return Number.isFinite(milliseconds) ? `${(milliseconds / 60000).toFixed(2)} 分钟` : '—';
    },
    hasResultFiles(task) {
      const files = task && task.resultFileUrls;
      if (Array.isArray(files)) return files.some(file => String(file || '').trim());
      return typeof files === 'string' && files.split(',').some(file => file.trim());
    },
    isDownloadingTask(id) { return Boolean(this.downloadingTasks[id]); },
    async downloadResultZip(task) {
      const id = task && task.id;
      if (id == null || this.isDownloadingTask(id)) return;
      this.$set(this.downloadingTasks, id, true);
      try {
        const response = await downloadTaskResultFiles(id);
        const blob = response && response.data;
        const contentType = response && response.headers && response.headers['content-type'];
        if (!blob || blob.size === 0) throw new Error('任务结果文件为空');
        if (contentType && contentType.includes('application/json')) {
          const text = await blob.text();
          let body;
          try { body = JSON.parse(text); } catch (error) { body = {}; }
          throw new Error((body && (body.message || body.error)) || '下载任务结果文件失败');
        }
        downloadFile(blob, `discount-conversion-${id}-result-files.zip`);
      } catch (error) {
        if (this.alive) this.$message.error(this.errorText(error));
      } finally {
        this.$delete(this.downloadingTasks, id);
      }
    },
    async loadOptions() {
      if (this.optionsLoading) return;
      this.optionsLoading = true;
      this.optionsError = '';
      try {
        const [vendors, seasons] = await Promise.all([getComboVendorListRF(true), seasonList()]);
        if (!vendors.data || vendors.data.success === false || !Array.isArray(vendors.data.data)) throw new Error('店铺选项加载失败');
        if (!seasons || seasons.success === false || !Array.isArray(seasons.data)) throw new Error('季节选项加载失败');
        if (this.alive) {
          this.vendors = vendors.data.data;
          this.vendorOptions = this.vendors.map(item => ({ label: item.vendorName, value: item.vendorId }));
          this.seasons = seasons.data;
        }
      } catch (error) {
        if (this.alive) {
          this.optionsError = this.errorText(error);
          this.$message.error(this.optionsError);
        }
      } finally {
        if (this.alive) this.optionsLoading = false;
      }
    },
    search() {
      this.appliedFilters = { ...this.filters };
      this.page = 1;
      this.loadTasks();
    },
    reset() { this.filters = emptyFilters(); },
    async loadTasks(silent = false) {
      clearTimeout(this.refreshTimer);
      const sequence = ++this.listSequence;
      if (!silent) this.listLoading = true;
      const params = {};
      Object.keys(this.appliedFilters).forEach(key => {
        const value = typeof this.appliedFilters[key] === 'string' ? this.appliedFilters[key].trim() : this.appliedFilters[key];
        if (value !== '' && value != null) params[key] = value;
      });
      try {
        const tasks = await getTasks(params);
        if (!this.alive || sequence !== this.listSequence) return;
        if (!Array.isArray(tasks)) throw new Error('任务列表响应格式错误');
        this.tasks = tasks;
        this.page = Math.min(this.page, Math.max(1, Math.ceil(tasks.length / this.pageSize)));
        if (this.detailVisible && !this.detailLoading) {
          const task = tasks.find(item => String(item.id) === String(this.detailId));
          if (task) this.detailTask = task;
        }
        if (this.active && tasks.some(task => task.status === 'PENDING' || task.status === 'RUNNING')) {
          this.refreshTimer = setTimeout(() => this.loadTasks(true), 5000);
        }
      } catch (error) {
        if (this.alive && sequence === this.listSequence) this.$message.error(this.errorText(error));
      } finally {
        if (this.alive && sequence === this.listSequence) this.listLoading = false;
      }
    },
    async loadRequirements() {
      if (this.requirementsLoading) return;
      this.requirementsLoading = true;
      this.requirementsError = '';
      try {
        const requirements = await getRequirements();
        if (!Array.isArray(requirements)) throw new Error('任务要求响应格式错误');
        if (this.alive) this.requirements = requirements;
      } catch (error) {
        if (this.alive) {
          this.requirementsError = this.errorText(error);
          this.$message.error(this.requirementsError);
        }
      } finally {
        if (this.alive) this.requirementsLoading = false;
      }
    },
    openRequirements() { this.requirementKeyword = ''; this.requirementsVisible = true; this.loadRequirements(); },
    openRequirementEditor(requirement) {
      this.requirementDraft = requirement ? { id: requirement.id, name: requirement.name, content: requirement.content } : { id: null, name: '', content: '' };
      this.requirementEditorVisible = true;
      this.$nextTick(() => this.$refs.requirementForm.clearValidate());
    },
    closeRequirementEditor(done) { if (!this.requirementSaving) done(); },
    saveRequirement() {
      if (this.requirementSaving) return;
      this.$refs.requirementForm.validate(async valid => {
        if (!valid) return;
        this.requirementSaving = true;
        const data = { name: this.requirementDraft.name.trim(), content: this.requirementDraft.content.trim() };
        try {
          if (this.requirementDraft.id == null) await createRequirement(data);
          else await updateRequirement(this.requirementDraft.id, data);
          if (!this.alive) return;
          this.requirementEditorVisible = false;
          this.$message.success('任务要求已保存');
          this.loadRequirements();
        } catch (error) {
          if (this.alive) this.$message.error(this.errorText(error));
        } finally {
          if (this.alive) this.requirementSaving = false;
        }
      });
    },
    openTask() {
      if (this.optionsError) this.loadOptions();
      this.taskDraft = emptyTask();
      this.taskSession += 1;
      this.requirementRows = [{ key: ++this.rowSequence, id: null }];
      this.uploading = { sourceFileUrls: false, caseSourceFileUrls: false, caseStandardFileUrls: false };
      this.taskVisible = true;
      this.loadRequirements();
      this.$nextTick(() => this.$refs.taskForm.clearValidate());
    },
    closeTask(done) { if (!this.taskSaving && !this.uploadBusy) done(); },
    requirementSelected(id, row) { return this.requirementRows.some(item => item.key !== row.key && String(item.id) === String(id)); },
    addRequirementRow() { this.requirementRows.push({ key: ++this.rowSequence, id: null }); },
    removeRequirementRow(key) {
      this.requirementRows = this.requirementRows.filter(row => row.key !== key);
      this.syncRequirementIds();
    },
    syncRequirementIds() {
      this.taskDraft.requirementIds = this.requirementRows.map(row => row.id).filter(id => id !== '' && id != null);
      this.$nextTick(() => this.$refs.taskForm.validateField('requirementIds'));
    },
    setFiles(key, urls) {
      this.$set(this.taskDraft, key, urls);
      if (key === 'sourceFileUrls') this.$refs.taskForm.validateField(key);
    },
    saveTask() {
      if (this.taskSaving || this.uploadBusy) return;
      this.$refs.taskForm.validate(async valid => {
        if (!valid) return;
        if (this.taskDraft.requirementIds.some(id => !this.enabledRequirements.some(item => String(item.id) === String(id)))) {
          this.$message.error('所选任务要求已停用或不存在，请重新选择');
          return;
        }
        this.taskSaving = true;
        try {
          await createTask({ ...this.taskDraft, taskName: this.taskDraft.taskName.trim(), category: this.taskDraft.category.join(','), season: this.taskDraft.season.join(',') });
          if (!this.alive) return;
          this.taskVisible = false;
          this.$message.success('任务已创建');
          this.page = 1;
          this.loadTasks();
        } catch (error) {
          if (this.alive) this.$message.error(this.errorText(error));
        } finally {
          if (this.alive) this.taskSaving = false;
        }
      });
    },
    openDetail(task, kind) {
      this.detailKind = kind;
      this.detailId = task.id;
      this.detailTask = null;
      this.detailVisible = true;
      this.loadDetail();
    },
    async loadDetail() {
      const sequence = ++this.detailSequence;
      this.detailLoading = true;
      this.detailError = '';
      try {
        const task = await getTask(this.detailId);
        if (!task || task.id == null) throw new Error('任务详情响应格式错误');
        if (this.alive && sequence === this.detailSequence) this.detailTask = task;
      } catch (error) {
        if (this.alive && sequence === this.detailSequence) {
          this.detailError = this.errorText(error);
          this.$message.error(this.detailError);
        }
      } finally {
        if (this.alive && sequence === this.detailSequence) this.detailLoading = false;
      }
    }
  }
};
</script>

<style>
.discount-conversion { --conversion-border: #e4e8f0; --conversion-muted: #7b8494; --conversion-primary: #2563eb; display: flex; flex-direction: column; width: 100%; height: 100%; min-height: 0; margin: 0; padding: 20px; color: #1f2733; font-size: 14px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", "PingFang SC", sans-serif; }
.conversion-heading { margin-bottom: 18px; }
.conversion-heading h1 { margin: 0; font-size: 20px; font-weight: 600; letter-spacing: .2px; }
.conversion-heading p { color: var(--conversion-muted); margin-top: 4px; font-size: 13px; }
.conversion-card { background: #fff; border: 1px solid var(--conversion-border); border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.03); overflow: hidden; }
.conversion-toolbar { display: flex; flex-shrink: 0; align-items: center; flex-wrap: wrap; gap: 14px; padding: 16px 18px; border-bottom: 1px solid var(--conversion-border); }
.conversion-toolbar .el-form-item { display: flex; margin: 0; align-items: center; }
.conversion-toolbar .el-form-item__label { color: var(--conversion-muted); font-size: 13px; white-space: nowrap; }
.conversion-toolbar .el-input { width: 150px; }
.conversion-toolbar .el-input__inner { border-radius: 8px; height: 36px; }
.conversion-actions { display: flex; gap: 10px; margin-left: auto; }
.conversion-actions .el-button + .el-button { margin-left: 0; }
.discount-conversion .el-button--primary, .conversion-dialog .el-button--primary { background: #2563eb; border-color: #2563eb; }
.discount-conversion .el-button--primary:hover, .conversion-dialog .el-button--primary:hover { background: #1d4ed8; border-color: #1d4ed8; }
.discount-conversion .el-button.is-disabled, .conversion-dialog .el-button.is-disabled { opacity: .55; }
.discount-conversion > .conversion-table { flex: 1; min-height: 0; }
.conversion-table th { background: #f9fafc; color: #7b8494; font-size: 12px; font-weight: 500; }
.conversion-table td { padding: 14px 0; font-size: 13px; }
.conversion-result-actions { display: flex; align-items: center; gap: 12px; }
.conversion-text-link { border: 0; background: none; color: var(--conversion-primary); cursor: pointer; font: inherit; padding: 4px 0; text-align: left; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.conversion-text-link:hover { text-decoration: underline; }
.conversion-text-link:focus-visible { outline: 2px solid var(--conversion-primary); outline-offset: 2px; }
.conversion-pagination { display: flex; flex-shrink: 0; justify-content: flex-end; padding: 16px 18px; overflow-x: auto; }
.conversion-dialog { max-width: calc(100vw - 32px); border-radius: 12px; }
.conversion-dialog .el-dialog__header { padding: 20px 24px 16px; border-bottom: 1px solid #e4e8f0; }
.conversion-dialog .el-dialog__title { font-size: 16px; font-weight: 600; }
.conversion-dialog .el-dialog__body { padding: 20px 24px; max-height: 65vh; overflow-y: auto; }
.conversion-dialog .el-dialog__footer { padding: 16px 24px; border-top: 1px solid #e4e8f0; }
.conversion-dialog .el-form-item__label { font-size: 13px; line-height: 22px; padding-bottom: 6px; }
.conversion-dialog .el-select { width: 100%; }
.conversion-dialog .el-input__inner, .conversion-dialog .el-textarea__inner { border-radius: 8px; }
.conversion-dialog .el-upload { text-align: left; }
.conversion-dialog .el-upload-list__item-name { max-width: 480px; }
.conversion-requirement-toolbar { display: flex; align-items: center; gap: 12px; }
.conversion-requirements { min-height: 180px; margin-top: 12px; }
.conversion-requirement { display: flex; align-items: flex-start; gap: 12px; padding: 16px 0; border-bottom: 1px solid #e4e8f0; }
.conversion-number { color: #7b8494; line-height: 24px; }
.conversion-requirement-body { flex: 1; min-width: 0; line-height: 1.8; overflow-wrap: anywhere; }
.conversion-requirement-body strong { font-weight: 600; font-size: 14px; }
.conversion-requirement-body p { white-space: pre-wrap; color: #7b8494; font-size: 13px; }
.conversion-requirement-input { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.conversion-requirement-input .el-select { flex: 1; min-width: 0; }
.conversion-requirement-input > span { width: 20px; color: #7b8494; }
.conversion-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.conversion-notice { background: #fff6f4; color: #a83d32; border-radius: 8px; margin: 8px 0; padding: 10px 14px; overflow-wrap: anywhere; }
.conversion-notice .el-button { padding: 4px 8px; }
.conversion-card > .conversion-notice { margin: 12px 18px; }
.conversion-empty { text-align: center; padding: 48px 0; color: #7b8494; }
.conversion-detail { min-height: 120px; }
.conversion-detail-meta { font-size: 12px; color: #7b8494; padding-bottom: 16px; }
.conversion-detail-text { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.8; }
.conversion-result { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 20px; }
.conversion-markdown { border: 1px solid #e4e8f0; border-radius: 10px; padding: 14px 16px; background: #f8faff; flex: 1; min-width: 0; overflow-wrap: anywhere; line-height: 1.8; }
.conversion-markdown > :first-child { margin-top: 0; }
.conversion-markdown > :last-child { margin-bottom: 0; }
.conversion-markdown h1, .conversion-markdown h2, .conversion-markdown h3, .conversion-markdown h4, .conversion-markdown h5, .conversion-markdown h6 { margin: 16px 0 8px; color: #303133; line-height: 1.4; }
.conversion-markdown p { margin: 8px 0; }
.conversion-markdown ul, .conversion-markdown ol { padding-left: 22px; margin: 8px 0; }
.conversion-markdown blockquote { border-left: 3px solid #c7d7f5; margin: 10px 0; padding: 2px 12px; color: #606b7a; }
.conversion-markdown pre { overflow: auto; padding: 12px; border-radius: 6px; background: #eef1f6; line-height: 1.5; }
.conversion-markdown code { padding: 2px 5px; border-radius: 4px; background: #eef1f6; font-family: Menlo, Consolas, monospace; font-size: 12px; }
.conversion-markdown pre code { padding: 0; background: transparent; }
.conversion-markdown a { color: #2563eb; word-break: break-all; }
.conversion-markdown-table-wrap { max-width: 100%; overflow-x: auto; }
.conversion-markdown table { border-collapse: collapse; min-width: 100%; margin: 10px 0; }
.conversion-markdown th, .conversion-markdown td { border: 1px solid #dfe4ec; padding: 6px 9px; text-align: left; }
.conversion-markdown th { background: #eef3fb; }
.conversion-agent { display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 8px; background: #eef4ff; color: #2563eb; font-size: 12px; flex-shrink: 0; }
@media (max-width: 760px) {
  .conversion-toolbar { gap: 12px; padding: 14px; }
  .conversion-toolbar .el-form-item { width: 100%; }
  .conversion-toolbar .el-form-item__label { width: 76px; text-align: left; }
  .conversion-toolbar .el-form-item__content { flex: 1; }
  .conversion-toolbar .el-input, .conversion-toolbar .el-select { width: 100%; }
  .conversion-actions { margin-left: 0; flex-wrap: wrap; }
  .conversion-form-grid { grid-template-columns: 1fr; gap: 0; }
  .conversion-requirement-toolbar { flex-wrap: wrap; }
}
</style>
